import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { CommissionCashbackMutationKeys } from '../../../keys'
import {
	UpdateCommissionCashbackRequest,
	UpdateCommissionCashbackResponse,
} from '../../../type'
import { updateCommissionCashback } from '../../services'

interface UpdateCommissionParams {
	id: string
	payload: UpdateCommissionCashbackRequest
}

export default function useMutationUpdateCommission(
	props?: UseBaseMutationOptions<
		UpdateCommissionCashbackResponse,
		UpdateCommissionParams
	>,
) {
	return useMutation({
		mutationKey: [CommissionCashbackMutationKeys.UpdateCommissionCashback],
		mutationFn: (params) => updateCommissionCashback(params.id, params.payload),
		...props,
	})
}
